export const translations = {
  no: {
    lang: 'no',
    flag: '\ud83c\uddf3\ud83c\uddf4',
    label: 'Norsk',
    nav: {
      what: 'Hva er Tempo',
      how: 'Slik fungerer det',
      features: 'Funksjoner',
      download: 'Last ned',
      privacy: 'Personvern',
    },
    hero: {
      kicker: 'DIN DIGITALE L\u00d8PECOACH',
      title1: 'Slutt \u00e5 lure p\u00e5',
      title2: 'hva du skal gj\u00f8re.',
      body: 'Tempo forteller deg n\u00f8yaktig hva du skal trene, n\u00e5r du skal hvile, og hva du b\u00f8r spise. Ingen planer \u00e5 tolke. Ingen apper \u00e5 sammenligne. Bare \u00e9n stemme som kjenner formen din \u2014 og holder deg i gang.',
      cta: 'Kom i gang',
      secondary: 'Hva er dette?',
    },
    what: {
      kicker: 'HVA ER TEMPO',
      title1: 'Ikke enda en treningsapp.',
      title2: 'En coach som gir deg svar.',
      body: 'Du vet at du burde trene mer strukturert. Du vet at du trenger en plan. Men du har ikke tid til \u00e5 sette deg inn i periodisering, laktatterskler og makrofordeling. Det er derfor Tempo finnes.',
      clarity: 'Klarhet',
      clarityBody: 'Hver morgen: \u00e9n melding. Hva du skal gj\u00f8re. Ferdig.',
      consistency: 'Konsistens',
      consistencyBody: 'Tre ok \u00f8kter i uka sl\u00e5r \u00e9n heroisk \u00f8kt. Alltid. Tempo vet dette.',
      progress: 'Fremgang',
      progressBody: 'Planen justeres etter kroppen din. Du merker forskjellen etter uker, ikke m\u00e5neder.',
    },
    pillars: {
      kicker: 'TRE PILARER',
      title: 'Alt du trenger. Ingenting mer.',
      items: [
        {
          label: 'DAGENS BESLUTNING',
          title: '\u00c9n beskjed. Ingen st\u00f8y.',
          body: '\u00abI dag: 6 km rolig i sone 2.\u00bb Det er alt du trenger \u00e5 vite. Tempo har analysert belastningen din, s\u00f8vnen, og ukeplanen \u2014 og kokt det ned til \u00e9n setning.'
        },
        {
          label: 'EKTE OPPF\u00d8LGING',
          title: 'Hoppet du over \u00f8kta? Greit. Men vi justerer.',
          body: 'Tempo dommer deg ikke. Men den later heller ikke som ingenting. Dropper du tirsdag, endres torsdagen. Slik holder du deg i bevegelse \u2014 uten \u00e5 falle av.'
        },
        {
          label: 'LEVENDE PLAN',
          title: 'En plan som puster.',
          body: 'Statiske 12-ukersplaner er laget for roboter. Tempo tilpasser seg. D\u00e5rlig uke? Planen roer seg. Flytsone? Den pusher deg. Du trenger ikke forst\u00e5 hvorfor. Bare stol p\u00e5 det.'
        },
      ],
    },
    howItWorks: {
      kicker: 'KOM I GANG',
      title: 'Fra null til plan p\u00e5 90 sekunder.',
      steps: [
        { num: '01', title: 'Sett m\u00e5let', body: '5K, 10K, halvmaraton eller maraton. Velg n\u00e5r du vil v\u00e6re klar. Tempo bygger planen din \u2014 fra dag \u00e9n.' },
        { num: '02', title: '\u00c5pne appen. Les meldingen.', body: 'Hver dag \u00e9n klar instruksjon. Ingen menyvalg, ingen innstillinger. Bare \u00abDette gj\u00f8r du i dag.\u00bb' },
        { num: '03', title: 'Gj\u00f8r jobben. Planen l\u00e6rer.', body: 'Etter \u00f8kten oppdateres alt. Neste dag tilpasses. Du trenger aldri \u00e5 planlegge selv igjen.' },
      ],
    },
    daily: {
      kicker: 'EN VANLIG TIRSDAG',
      title: 'Slik ser en dag med Tempo ut.',
      items: [
        { time: '07:15', msg: '\u00abI dag: 8 km rolig. Sone 2. Ikke jag fart \u2014 bare hold rytmen.\u00bb' },
        { time: '11:30', msg: '\u00abDu trener i dag. Hold middagen enkel \u2014 pasta og kylling holder.\u00bb' },
        { time: '19:45', msg: '\u00ab8.2 km, snitt 5:34. Solid. Neste \u00f8kt torsdag \u2014 intervaller.\u00bb' },
      ],
      tagline: 'Ingen beslutninger. Ingen tvil. Bare gjennomf\u00f8ring.',
    },
    features: {
      kicker: 'UNDER PANSERET',
      title: 'Bygget for l\u00f8pere som mener det.',
      items: [
        { title: 'AI som husker alt', body: 'Tempos coach vet hva du trente forrige uke, hvordan kroppen responderte, og hva som er neste logiske steg. Den glemmer ingenting.' },
        { title: 'Periodisering p\u00e5 autopilot', body: 'Base. Oppbygging. Topp. Nedtrapping. Tempo styrer fasene for deg \u2014 s\u00e5 du bare trenger \u00e5 m\u00f8te opp.' },
        { title: 'Mat som gir mening', body: 'Ikke en diett. En enkel anbefaling: \u00abhva b\u00f8r du spise i dag, basert p\u00e5 \u00f8kten?\u00bb Konkret. Kort. Nyttig.' },
      ],
    },
    notFor: {
      kicker: '\u00c6RLIG TALT',
      title: 'Tempo er ikke for alle.',
      notLabel: 'DETTE ER IKKE FOR DEG',
      notItems: [
        'Du vil ha en sosial l\u00f8peapp med likes og kommentarer',
        'Du trener allerede med en personlig trener',
        'Du bare vil tracke km \u2014 ikke bli bedre',
      ],
      yesLabel: 'DETTE ER FOR DEG',
      yesItems: [
        'Du l\u00f8per, men vet du egentlig trener riktig',
        'Du har pr\u00f8vd planer f\u00f8r, men faller alltid av etter tre uker',
        'Du vil ha en som sier \u00abhei, dette skal du gj\u00f8re n\u00e5\u00bb',
      ],
    },
    download: {
      title: 'Klar for \u00e5 slutte \u00e5 gjette?',
      subtitle: 'Last ned Tempo. F\u00e5 din f\u00f8rste \u00f8kt i morgen.',
      appstore: 'App Store (kommer)',
      playstore: 'Google Play (kommer)',
    },
    footer: {
      copyright: 'Bygget for de som m\u00f8ter opp.',
      company: 'Et produkt av Kviteberg AS',
      orgNr: 'Org.nr. 834 606 402',
      privacy: 'Personvern',
      terms: 'Vilk\u00e5r',
      contact: 'Kontakt',
    },
  },
  en: {
    lang: 'en',
    flag: '\ud83c\uddec\ud83c\udde7',
    label: 'English',
    nav: {
      what: 'What is Tempo',
      how: 'How it works',
      features: 'Features',
      download: 'Download',
      privacy: 'Privacy',
    },
    hero: {
      kicker: 'YOUR DIGITAL RUNNING COACH',
      title1: 'Stop wondering',
      title2: 'what to do next.',
      body: 'Tempo tells you exactly what to train, when to rest, and what to eat. No plans to interpret. No apps to compare. Just one voice that knows your body \u2014 and keeps you moving.',
      cta: 'Get started',
      secondary: 'What is this?',
    },
    what: {
      kicker: 'WHAT IS TEMPO',
      title1: 'Not another training app.',
      title2: 'A coach that gives you answers.',
      body: 'You know you should train smarter. You know you need a plan. But you don\u2019t have time to study periodization, lactate thresholds and macro splits. That\u2019s why Tempo exists.',
      clarity: 'Clarity',
      clarityBody: 'Every morning: one message. What to do. Done.',
      consistency: 'Consistency',
      consistencyBody: 'Three decent sessions a week beats one heroic effort. Always. Tempo knows this.',
      progress: 'Progress',
      progressBody: 'The plan adjusts to your body. You\u2019ll feel the difference in weeks, not months.',
    },
    pillars: {
      kicker: 'THREE PILLARS',
      title: 'Everything you need. Nothing more.',
      items: [
        {
          label: 'TODAY\u2019S DECISION',
          title: 'One message. No noise.',
          body: '\u201cToday: 6 km easy in zone 2.\u201d That\u2019s all you need to know. Tempo has analyzed your load, your sleep, and your weekly plan \u2014 and distilled it into one sentence.'
        },
        {
          label: 'REAL ACCOUNTABILITY',
          title: 'Skipped your session? Fine. But we adjust.',
          body: 'Tempo doesn\u2019t judge you. But it doesn\u2019t pretend nothing happened either. Skip Tuesday, Thursday changes. That\u2019s how you keep moving \u2014 without falling off.'
        },
        {
          label: 'LIVING PLAN',
          title: 'A plan that breathes.',
          body: 'Static 12-week plans are built for robots. Tempo adapts. Rough week? The plan calms down. In the zone? It pushes you. You don\u2019t need to understand why. Just trust it.'
        },
      ],
    },
    howItWorks: {
      kicker: 'GET STARTED',
      title: 'From zero to plan in 90 seconds.',
      steps: [
        { num: '01', title: 'Set your goal', body: '5K, 10K, half marathon or marathon. Pick when you want to be ready. Tempo builds your plan \u2014 from day one.' },
        { num: '02', title: 'Open the app. Read the message.', body: 'Every day one clear instruction. No menu choices, no settings. Just \u201cThis is what you do today.\u201d' },
        { num: '03', title: 'Do the work. The plan learns.', body: 'After the session, everything updates. Tomorrow adapts. You never have to plan again.' },
      ],
    },
    daily: {
      kicker: 'A REGULAR TUESDAY',
      title: 'This is what a day with Tempo looks like.',
      items: [
        { time: '07:15', msg: '\u201cToday: 8 km easy. Zone 2. Don\u2019t chase pace \u2014 just hold the rhythm.\u201d' },
        { time: '11:30', msg: '\u201cYou\u2019re training today. Keep dinner simple \u2014 pasta and chicken will do.\u201d' },
        { time: '19:45', msg: '\u201c8.2 km, avg 5:34/km. Solid. Next session Thursday \u2014 intervals.\u201d' },
      ],
      tagline: 'No decisions. No doubt. Just execution.',
    },
    features: {
      kicker: 'UNDER THE HOOD',
      title: 'Built for runners who mean it.',
      items: [
        { title: 'AI that remembers everything', body: 'Tempo\u2019s coach knows what you trained last week, how your body responded, and what the next logical step is. It forgets nothing.' },
        { title: 'Periodization on autopilot', body: 'Base. Build. Peak. Taper. Tempo manages the phases for you \u2014 so you just need to show up.' },
        { title: 'Food that makes sense', body: 'Not a diet. A simple recommendation: \u201cwhat should you eat today, based on the session?\u201d Concrete. Brief. Useful.' },
      ],
    },
    notFor: {
      kicker: 'HONESTLY',
      title: 'Tempo isn\u2019t for everyone.',
      notLabel: 'THIS ISN\u2019T FOR YOU',
      notItems: [
        'You want a social running app with likes and comments',
        'You already train with a personal coach',
        'You just want to track km \u2014 not get better',
      ],
      yesLabel: 'THIS IS FOR YOU',
      yesItems: [
        'You run, but you\u2019re not sure you\u2019re training right',
        'You\u2019ve tried plans before but always fall off after three weeks',
        'You want someone to say \u201chey, this is what you do now\u201d',
      ],
    },
    download: {
      title: 'Ready to stop guessing?',
      subtitle: 'Download Tempo. Get your first session tomorrow.',
      appstore: 'App Store (coming)',
      playstore: 'Google Play (coming)',
    },
    footer: {
      copyright: 'Built for those who show up.',
      company: 'A product by Kviteberg AS',
      orgNr: 'Org. no. 834 606 402',
      privacy: 'Privacy',
      terms: 'Terms',
      contact: 'Contact',
    },
  },
};

export default translations;
